/* eslint-disable */
import {
  createContext,
  useContext,
  useReducer,
  useMemo,
  useEffect,
} from "react";
import api from "api";
import { NotificationManager } from "react-notifications";
import axios from "axios";
import addNewLog from "utils/addNewLog";
import { ErrorHandelFunctionApp } from "utils/ErrorHandelFunction";
// Auth context
const authContext = createContext();
// Setting custom name for the context which is visible on react dev tools
authContext.displayName = "Auth Context";

// reducer
function reducer(state, action) {
  switch (action.type) {
    case "INIT": {
      return { ...state, ...action.payload };
    }
    case "LOGIN": {
      return { ...state, ...action.value, isLoggedIn: true };
    }
    case "SET_USER_DETAILS": {
      return { ...state, ...action.value, userDetails: action.value };
    }
    case "LOGOUT": {
      return { token: "", expiration: null, isLoggedIn: false };
    }
    default: {
      throw new Error(`Unhandled action type: ${action.type}`);
    }
  }
}
const expiration = localStorage.getItem("expiration");
const esriExpires = localStorage.getItem("esriExpiration");
let token;
let esriToken;
const isEsriTokenExpired =
  esriExpires && Number(esriExpires) > new Date().getTime();
// if token is expired, logout
if (isEsriTokenExpired) {
  token = localStorage.getItem("token");
  esriToken = localStorage.getItem("esriToken");
} else {
  localStorage.removeItem("token");
  localStorage.removeItem("esriToken");
}
// context provider
function AuthContextProvider({ children }) {
  const initialState = {
    token,
    esriToken,
    isLoggedIn: !!token,
    otpRequired: false,
    userDetails: null,
    expiration,
    esriExpires,
    ipAddress: "",
    hostname: "",
  };

  const [controller, dispatch] = useReducer(reducer, initialState);

  const value = useMemo(() => [controller, dispatch], [controller, dispatch]);

  useEffect(() => {
    (async () => {
      if (controller.token) {
        await getUserInfo(dispatch);
        await getUserPCInfo(dispatch);
      }
    })();
  }, [controller.token]);

  return <authContext.Provider value={value}>{children}</authContext.Provider>;
}

// custom hook for using context
function useAuth() {
  const context = useContext(authContext);

  if (!context) {
    throw new Error("useAuth should be used inside the AuthContextProvider.");
  }

  return context;
}

async function getUserInfo(dispatch, token) {
  try {
    const userDetailsRes = await api.get("/users/details", {
      headers: { "access-token": token || localStorage.getItem("token") },
    });
    dispatch({
      type: "INIT",
      payload: { userDetails: userDetailsRes.data.data },
    });
  } catch (error) {
    ErrorHandelFunctionApp(error)
  }
}

async function getUserPCInfo(dispatch) {
  try {
    const userDetailsRes = await axios.get(
      "https://sp.pdtra.gov.jo/MachineLogService/RestServiceImpl.svc/logMachineDetails"
    );
    dispatch({
      type: "INIT",
      payload: {
        ipAddress: userDetailsRes?.data?.ip,
        hostname: userDetailsRes?.data?.machineIName,
      },
    });
  } catch (error) {
    ErrorHandelFunctionApp(error)
  }
}

// Context module functions
const handleLogin = async (dispatch, value, userType) => {
  try {
    const data = {
      ...value,
    };
    if (!data.otpNumber) {
      delete data.otpNumber;
    }
    const peopleUrl = `${process.env.REACT_APP_Petra_API_ENDPOINT}users/auth/login`;
    const adminUrl = `${process.env.REACT_APP_Petra_API_ENDPOINT}users/auth/admin/login`;
    const options = {
      method: "POST",
      data,
      url: userType === "user" ? peopleUrl : adminUrl,
    };

    
    const res = await axios(options);
    if (res.data.data.otpVerificationRequired) {
      dispatch({ type: "INIT", payload: { otpRequired: true } });
      return;
    }
    if (res.data.error) {
      throw res.data.error;
    }

    localStorage.setItem("token", res.data.data.token);
    localStorage.setItem("esriToken", res.data.data.esriToken);
    localStorage.setItem("expiration", res.data.data.expiration);
    localStorage.setItem(
      "esriExpiration",
      /* Date.now() + */ res.data.data.esriExpires
    );

    // get user details

    getUserInfo(dispatch, res.data.data.token);

    if (userType === "employee") {
      try {
        const userDetailsRes = await axios.get(
          "https://sp.pdtra.gov.jo/MachineLogService/RestServiceImpl.svc/logMachineDetails"
        );
        const logMachineData = userDetailsRes.data;
        // hostname: userDetailsRes?.data?.machineIName,
        dispatch({
          type: "INIT",
          payload: {
            ipAddress: logMachineData?.ip,
            hostname: logMachineData?.machineIName,
          },
        });

        await addNewLog({
          ipAddress: logMachineData?.ip,
          hostname: logMachineData?.machineIName,
          logDescription: "تسجيل دخول",
        });
      } catch (error) {
        ErrorHandelFunctionApp(error)
      }
    }

    dispatch({
      type: "INIT",
      payload: {
        token: res.data.data.token,
        esriToken: res.data.data.esriToken,
        expiration: res.data.data.expiration,
        esriExpires: res.data.data.esriExpires,
        isLoggedIn: true,
      },
    });

    NotificationManager.success("تم تسجيل الدخول بنجاح");
    return true;
  } catch (error) {
    ErrorHandelFunctionApp(error)
    if (error && error.response) {
      const isEmployeePath = location.pathname.match(/employee/);
      if (error.response.data.message) {
        NotificationManager.error(error.response.data.message);
      } else if (isEmployeePath)
        NotificationManager.error("احد المعلومات المدخلة غير صحيحة");
      else NotificationManager.error("الرقم الوطني او معلومات المكتب غير صحيح");
    }
    localStorage.clear();
    
  }
};

const handleLogout = async (dispatch, isPeople) => {
  try {
    localStorage.clear();
    dispatch({ type: "LOGOUT" });
    NotificationManager.success("تم تسجيل الخروج بنجاح");
    const { origin } = window.location;
    if (!isPeople) {
      window.location.pathname = `/petraparcels/auth/login/employee`;
    } else {
      window.location.pathname = `/petraparcels/auth/login`;
    }
  } catch (error) {
    ErrorHandelFunctionApp(error)
  }
};

export { AuthContextProvider, useAuth, handleLogin, handleLogout };
